import React, { useCallback, useEffect } from 'react'
import Dashboard from '../components/Dashboard';
import { Routes, Route, useNavigate } from "react-router-dom";
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import OktaConfig from '../OktaConfig';
import Home from "../components/Home";
import TrackNTrace from '../components/pages/TrackNTrace';
import CarrierPerformance from '../components/pages/CarrierPerformance';
import OnTimePickup from '../components/performance/OnTimePickup';
import OnTimeDelivery from '../components/performance/OnTimeDelivery';
import CarrierEventResponse from '../components/performance/CarrierEventResponse';
import FirstTenderCompliance from '../components/performance/FirstTenderCompliance';
import useUniqTab from '../helpers/UniqTab';
import CarrierLayout from './CarrierLayout';
import LaneAwardCompliance from '../components/performance/LaneAwardCompliance';
import TrailerPoolCompliance from '../components/performance/TrailerPoolCompliance';
import ProtectedRoutes from './ProtectedRoutes';
import DailyMaintenance from "../components/pages/DailyMaintenance";
import BidMaintenance from "../components/pages/BidMaintenance";
import LeftMenuLayout from '../components/tmt/LeftMenuLayout';
import AuditHistoryDetails from '../components/pages/AuditHistoryDetails';
import CoupaFileDeleteDetails from '../components/pages/CoupaFIleDeleteDetails';
import DrmtReports from '../components/pages/DrmtReports';
import CeaProfileDownload from '../components/pages/CeaProfileDownload';

const oktaAuth = new OktaAuth(OktaConfig);
const NotFound = () => <h1>Page Not Found</h1>;

const RoutePath = () => {
    const navigate = useNavigate();

    const restoreOriginalUri = useCallback(async (_oktaAuth, originalUri) => {
        // const to = originalUri || "/dashboard";
        // navigate(to, { replace: true })
        navigate(toRelativeUrl(originalUri || '/', window.location.origin));
    }, [])

    useUniqTab();

    /* 
    Following useEffect is a fix for warning: 
    Two custom restoreOriginalUri callbacks are detected. 
    The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component. 
    */
    useEffect(() => {
        return () => {
            oktaAuth.options.restoreOriginalUri = undefined
        }
    }, [])
    return (
        <Security restoreOriginalUri={restoreOriginalUri} oktaAuth={oktaAuth}>
            <Routes>
                <Route path='/' exact={true} element={<Home />} />
                <Route path='/dashboard' element={<Dashboard />} >
                    <Route element={<ProtectedRoutes />}>
                        <Route index element={<TrackNTrace />} />
                        <Route path="tracking" element={<TrackNTrace />} />
                        <Route path="performance" element={<CarrierLayout />}>
                            {/* <=====================================================> */}
                            {/* Also add reference paths in helper file , we will be needing in regenerating paths */}
                            {/* <=====================================================> */}
                            <Route path="" index element={<CarrierPerformance />} />
                            <Route path=":carrierid" element={<CarrierPerformance />} />
                            <Route path=":carrierid/onTimePickup" element={<OnTimePickup />} />
                            <Route path=":carrierid/onTimeDelivery" element={<OnTimeDelivery />} />
                            <Route path=":carrierid/firstTenderCompliance" element={<FirstTenderCompliance />} />
                            <Route path=":carrierid/laneAwardCompliance" element={<LaneAwardCompliance />} />
                            <Route path=":carrierid/trailerPoolCompliance" element={<TrailerPoolCompliance />} />
                            <Route path=":carrierid/carrierEventResponse" element={<CarrierEventResponse />} />
                        </Route>
                        {/* <Route exact path="tmt" element={<TMT />} /> */}
                        {process.env.REACT_APP_ENV !== 'production' && 
                        (<Route path="drm_tool" element={<LeftMenuLayout />}>
                            <Route index element={<DailyMaintenance />} />
                            <Route path="daily_maintenance" element={<DailyMaintenance />} />
                            <Route path="bid_maintenance" element={<BidMaintenance />} />
                            <Route path="drm_report" element={<DrmtReports />} />
                            <Route path="audit_history" element={<AuditHistoryDetails />}></Route>
                            <Route path="coupa_file_management" element={<CoupaFileDeleteDetails />}></Route>
                            <Route path="cea_profile_download" element={<CeaProfileDownload />}></Route>
                        </Route>)}
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Route>
                <Route path='/callback' element={<LoginCallback />} />
                
                <Route path='/*' element={<NotFound />} />
            </Routes>
        </Security>
    )
}

export default RoutePath;